<div class="version-banner" fxLayout="row">
  <div fxFlex="" class="version-banner__font">Version: {{ buildVersion }}</div>
</div>
